import { cn } from "@/lib/utils";
import * as React from "react";

const Input = React.forwardRef<
	HTMLInputElement,
	React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => (
	<input
		type={type}
		ref={ref}
		className={cn(
			"flex h-9 w-full rounded-lg border border-input bg-surface-primary px-3 py-1 text-body text-foreground transition-colors",
			"placeholder:text-muted2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
			"disabled:cursor-not-allowed disabled:opacity-50",
			className,
		)}
		{...props}
	/>
));
Input.displayName = "Input";

export { Input };
